import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
  This is a non-visual component which detects a click outside of its component boundaries to
  trigger a callback function
*/
class ClickOutside extends Component {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { callback } = this.props;
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      callback();
    }
  };

  render() {
    const { children } = this.props;

    return <div ref={this.wrapperRef}>{children}</div>;
  }
}

ClickOutside.propTypes = {
  /**
    The component(s) that are being wrapped by the `ClickOutside` component
  */
  children: PropTypes.element.isRequired,
  /**
    The callback that is triggered when the user clicks outside the component boundary
  */
  callback: PropTypes.func.isRequired,
};

export default ClickOutside;
